import { PageContent } from "../content/pages";

type EventTypes2Props = {
  eventTypes: PageContent['eventTypes'];
};

const EventTypes2 = ({ eventTypes }: EventTypes2Props) => {
  // Determine width class based on number of items
  const getWidthClass = (totalItems: number) => {
    switch (totalItems) {
      case 3:
        return 'md:w-[384px]';  // 1216px ÷ 3 = ~384px
      case 4:
        return 'md:w-1/4';      // 25%
      case 5:
        return 'md:w-1/5';      // 20%
      default:
        return 'md:w-1/5';
    }
  };

  const widthClass = getWidthClass(eventTypes?.length || 0);

  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-3xl md:text-4xl font-semibold mb-12 text-gray-900">
          Perfect for
        </h2>
        
        <div className="flex flex-col md:flex-row gap-6 md:gap-6 max-w-[1216px] mx-auto md:justify-center">
          {eventTypes?.map((eventType, index) => (
            <div key={index} className={`w-full ${widthClass} md:bg-gray-50 md:rounded-xl md:px-4 md:pb-8 md:text-center`}>
              <div className="flex md:block items-center">
                <div className="flex justify-end md:justify-center md:-mt-6">
                  <div 
                    className="w-12 h-12 bg-contain bg-center bg-no-repeat text-white"
                    style={{ backgroundImage: `url(${eventType.icon})` }}
                  />
                </div>
                <div>
                  <h3 className="text-gray-900 text-lg md:text-xl font-semibold ml-4 md:ml-0 md:mt-5 md:mb-2">
                    {eventType.title}
                  </h3>
                  {eventType.description && (
                    <p className="text-gray-600 text-base ml-4 md:ml-0">
                      {eventType.description}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventTypes2; 